module.exports = __webpack_public_path__ + "media/images/contest_banners/contests-5-banner-bb4e77b030c36dd06560bf76783160fc.png";